<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Ingresos y egresos " titleLevel="h1">
          <template slot="partOne">Ingresos<br></template>
          <template slot="partThree"> y egresos </template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Ingresos y egresos'" videoEmbed="ADMINISTRACIONDINERO15IngresosEgresos (ant46).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Si los
          <strong>ingresos o entradas</strong> son mayores a los
          <strong>gastos o salidas</strong>, el flujo de caja es
          <strong>positivo <span aria-hidden="true">(+)</span></strong>. Si los
          <strong>gastos o salidas</strong> son mayores a los
          <strong>ingresos o entradas</strong>, el flujo de efectivo es
          <strong>negativo <span aria-hidden="true">(-)</span></strong>.<br><br> Un
          <strong>flujo de efectivo</strong> positivo significa poder pagar las cuentas a tiempo y poder cubrir cualquier otro gasto inmediato. Pero lo más importante es que permite
          <strong>ahorrar</strong> para la seguridad financiera frente a una emergencia, para adquirir un bien más adelante o para el momento del retiro.
          <audio-player ref="audioPlayer" :audios="[
            'admin3y4juntos.mp3'
            ]"></audio-player>
        </p>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="230" imaSrc="contenido/diapositiva_16" imaAlt="Mujer sonriendo con la mano en la cintura"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>


<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
    setTimeout(()=>{this.$refs.audioPlayer.playAudio(0)},1000);        
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-15.vue?4e2678c6